import { useNavigate } from 'react-router-dom';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CardAction from '../../../../../components/card/CardAction';

const defaultProps = {
  className: '',
};

/**
 * Copy Lesson Action Container
 */
export default function EditLessonAction(p) {
  const {
    lesson,
    className,
  } = { ...defaultProps, ...p };
  const navigate = useNavigate();
  return (
    <CardAction
      icon={<BorderColorIcon aria-hidden='false' />}
      actionHandler={() => { navigate(`/lessons/${lesson.attributes.uuid}/update`); }}
      className={className}
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
